import React, { useState, useEffect } from 'react'
import { useTranslation } from "react-i18next"
import { formatAsMoney, GetAlertsComponent, validateConstantValues } from "./utils"
import IconButton from '@material-ui/core/IconButton'
import CloseIcon from '@material-ui/icons/Close'
import Tooltip from "@material-ui/core/Tooltip"
import HelpIcon from "@material-ui/icons/Help"
import CurrencyInput from 'react-currency-input'
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

let this_box_type = "number"

export function ConstantAmountBox(props) {
    const { t } = useTranslation()
    let { node, read_only, handleConfigurationOpen, handleNodeRemove } = props

    return (
        <div>
            <div style={{display:"flex", alignItems: "center"}}>
                <div
                    style={{ display: "flex", width: "100%", cursor: "pointer", margin: "0px" }}
                    onClick={() => handleConfigurationOpen(node)}
                >
                    <div style={{ display: "flex", flexDirection: "column", margin: "auto 0px" }}>
                        <div className={["normalText", "normalMediumSize"].join(" ")}>
                            {t(node.node.description)}
                        </div>
                        <div className={["normalText", "normalSmallSize"].join(" ")}>
                            {node.node.properties.value ? formatAsMoney(node.node.properties.value) : ""}
                        </div>
                    </div>
                    {!read_only && (node.node.alerts || []).length > 0 ?
                        <GetAlertsComponent alerts={node.node.alerts} /> : null}
                </div>
                {!read_only && <><IconButton style={{width: 32, height: 32}} aria-label="duplicate" onClick={() => props.handleNodeDuplication(node)}>
                        <ContentCopyIcon style={{width: 20, height: 20}} />
                    </IconButton>
                    <IconButton style={{width: 32, height: 32}} aria-label="close" onClick={() => handleNodeRemove(node)}>
                        <CloseIcon style={{width: 20, height: 20}} />
                    </IconButton></>}
            </div>
        </div>
    )
}

export function ConstantAmountConfiguration(props) {
    const { t } = useTranslation()
    let { node, read_only, handleNodeChange, handleConfigurationClose } = props

    let initial_value = node.node.properties.value ? formatAsMoney(node.node.properties.value) : 0
    const [nodeState, setNodeState] = useState(node)
    const [moneyValue, setMoneyValue] = useState(initial_value)

    useEffect(() => {
        setNodeState(node)
    }, [node])

    const handleNodeStateChange = (obj_key, value) => {
        let new_node = { ...nodeState }
        new_node.node.properties[obj_key] = value
        setMoneyValue(value)
        setNodeState(new_node)
    }

    const handleSave = () => {
        handleConfigurationClose()
        let new_node = { ...nodeState }
        if (!(typeof new_node.node.properties.value === 'number')){
            new_node.node.properties.value = Number(new_node.node.properties.value.replace(/[.,R$ ]/g, ''))
        }
        handleNodeChange(new_node)
    }


    const validateAllValues = () => {
        return (
            (!!nodeState.node.properties.value)
        )
    }

    return (
        <div style={{ flexGrow: "1", padding: "20px", display: "flex", flexDirection: "column" }}>
            <div style={{ display: "flex" }}>
                <span className={["blueText", "subtitleSize", "labelSpace"].join(" ")}>{t(node.node.description)}</span>
                <Tooltip title={<div className="tooltipText"><ul>{node.node.helperText.map((help, index) => (<li key={index}>{t(help)}</li>))}</ul></div>}>
                    <HelpIcon style={{ fontSize: "14px", display: "flex", margin: "auto 5px" }} />
                </Tooltip>
            </div>
            <div className="internalCardContainer" style={{ display: "flex", flexDirection: "column" }}>
                <CurrencyInput
                    precision="2"
                    decimalSeparator=","
                    thousandSeparator="."
                    prefix="R$ "
                    size="small"
                    name="amount"
                    className={!validateConstantValues(this_box_type, nodeState.node.properties.value) ? "filterCurrencyCreditError" : "filterCurrencyCredit"}
                    value={moneyValue}
                    onChange={(e) => handleNodeStateChange("value", e)}
                    style={{ width: 'clamp(200px, 220px, 300px)', marginLeft: '20px' }}
                />
            </div>
            <div style={{ display: "flex", margin: "auto auto 5px auto" }}>
                <div
                    className={["button", "onlyboarder", "normalText", "normalMediumSize"].join(" ")}
                    style={{ width: "120px" }}
                    onClick={handleConfigurationClose}
                >
                    {read_only ? "X" : t("discard")}
                </div>
                {!read_only &&
                    <div
                        className={
                            validateAllValues()
                                ?
                                ["button", "standard", "normalText", "normalMediumSize"].join(" ")
                                :
                                ["button", "standard", "normalText", "normalMediumSize", "disabled"].join(" ")}
                        style={{ width: "120px" }}
                        onClick={validateAllValues() ? handleSave : null}
                    >
                        {t("save")}
                    </div>}
            </div>
        </div>
    )
}

export class ConstantAmountBoxClass {
    constructor(rulesContext) {
        this.rulesContext = rulesContext
    }

    validate(node) {
        let put_error = false
        let alerts = []

        if ((node.node.children || []).length !== 0) {
            put_error = true
            alerts.push("box_validation_no_children_allowed")
        }
        //Validate value is not length 0
        if (!validateConstantValues(this_box_type, node.node.properties.value)) {
            put_error = true
            alerts.push("box_validation_no_null_value_allowed")
        }
        //Validate if parent is valid
        if (node.parentNode != null) {
            if (node.parentNode.on_error) {
                put_error = true
                alerts.push("box_validation_invalid_parent_node")
            }
        }
        return { validated: !put_error, alerts: alerts }
    }

    getType(node) {
        return this_box_type
    }
}